import React, { FC } from "react";


const Footer:FC = () => {
    const year = new Date().getFullYear();

    return <div style={{maxHeight:'20px',width:'100%', 'margin':'2rem 0rem 1rem 0rem', textAlign:'center'}}>
        <hr style={{background:'white'}}/>
        Copyright © 2019 - {year} Alpha Controls & Services, LLC All Rights Reserved.
        <div style={{marginBottom:'1rem'}}><a href="/terms_and_conditions" target="_blank"> Terms & Conditions</a> - <a href="/privacy" target="_blank"> Privacy Policy </a></div>
    </div>
};

export default Footer;